import React, { FC } from 'react'

interface Props {
  label: string
  value?: string
  className?: string
}

const DetailRow: FC<Props> = ({ label, value, children, className = '' }) => (
  <div className={`d-flex flex-wrap align-items-center ${className}`}>
    <div className="flex-grow-1">
      <span className="d-inline-block w-100 placeholder-text">{label}</span>
      <span className="d-inline-block w-100">{value || '-'}</span>
    </div>
    {children}
  </div>
)

export default DetailRow
